import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getBlockTypesForDeviation } from '../../Moderation/redux/selectors';
import { BlockReasons } from '../../Moderation/redux/types';
var matureReasons = [BlockReasons.MatureAge, BlockReasons.MatureFilter];
export function useDeviationMatureFilter(deviation) {
    var blockReasons = useSelector(function (state) { return deviation && getBlockTypesForDeviation(state, deviation); }) || [];
    var _a = useState(false), matureFilterDisabled = _a[0], setMatureFilterDisabled = _a[1];
    // reset mature filter override when deviation changes
    var _b = (deviation || {}).deviationId, deviationId = _b === void 0 ? 0 : _b;
    useEffect(function () {
        setMatureFilterDisabled(false);
    }, [deviationId]);
    var hasNonOverridableBlockReasons = blockReasons.some(function (reason) { return !matureReasons.includes(reason); });
    var hasOverridableMatureBlockReasons = blockReasons.some(function (reason) {
        return matureReasons.includes(reason);
    });
    var props = useMemo(function () { return ({
        showBlocked: hasNonOverridableBlockReasons ||
            (hasOverridableMatureBlockReasons && !matureFilterDisabled),
        overrideMatureFilter: function () { return setMatureFilterDisabled(true); },
    }); }, [
        hasNonOverridableBlockReasons,
        hasOverridableMatureBlockReasons,
        matureFilterDisabled,
    ]);
    return props;
}
//# sourceMappingURL=useDeviationMatureFilter.js.map